export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11509.d69dd028.jpg";